import React, { useState, useEffect, useRef } from 'react';
import './BotCharacter.css';

import normalImg   from '../../img/botStatus/normal.png';
import pensandoImg from '../../img/botStatus/pensando.png';
import apuradoImg  from '../../img/botStatus/apurado.png';
import risaImg     from '../../img/botStatus/risa.png';
import enojoImg    from '../../img/botStatus/enojo.png';

// ── Winning positions ─────────────────────────────────────────────────────────

const WIN_POS = [
  [0,1,2],[3,4,5],[6,7,8],
  [0,3,6],[1,4,7],[2,5,8],
  [0,4,8],[2,4,6],
];

// Cuántas amenazas ganadoras tiene un jugador en el tablero actual
function countThreats(squares, player) {
  let count = 0;
  for (const [a, b, c] of WIN_POS) {
    const vals = [squares[a]?.value, squares[b]?.value, squares[c]?.value];
    const mine  = vals.filter(v => v === player).length;
    const empty = vals.filter(v => v === '').length;
    if (mine === 2 && empty === 1) count++;
  }
  return count;
}

// ── Frases por situación ──────────────────────────────────────────────────────

const PHRASES = {

  // Estado base, frases random + las tres especiales mezcladas
  normal: [
    'Cuando quieras… sin apuro.',
    'Nací listo. ¿Vos?',
    'He visto mejores movidas en un entrenamiento de quinta.',
    'Las reglas las sabemos los dos.',
    'La estoy pasando mejor de lo que debería.',
    'Tomá tu tiempo. Me gusta verte sufrir.',
    'Mis circuitos andan fríos hoy. 🥶',
    'El fútbol es vida. Esto también.',
    'Aprendí del mejor. Yo mismo.',
    'Procesando… era joda, ya estaba listo.',
    'Estadísticamente, tenés chances. Estadísticamente.',
    'No es personal. Bueno, sí un poco.',
    'Jugamos o te quedás mirando?',
    '¿Un cartero celebra cuando entrega una carta?',
    'Cuando la pelota entró, ya sabía que era gol.',
    'El equipo que mete más goles gana el partido.',
  ],

  // Bot está pensando su jugada
  pensando: [
    'Hmm… calculando cada posible resultado.',
    'Dame un segundo. Esto es serio.',
    'No estoy dilatando. Estoy siendo brillante.',
    '…',
    'Mi CPU al 100%. Solo por vos.',
    'Analizando… analizando… analizando…',
    'Genio en acción, aguantá.',
    'Toda gran jugada empieza con un gran pensamiento.',
    'Veo tu tablero. Veo tu futuro.',
    'La paciencia es una virtud. Sobre todo la mía.',
    'No te me vayas, esto tarda nada.',
    'Podría jugar al toque… pero prefiero hacerlo bien.',
    'Cada movida que hago es una obra maestra. Tenelo claro.',
  ],

  // ≤15 segundos en el turno del usuario
  apurado: [
    'Tic… tac… tic… tac… ⏱️',
    '¡El reloj no miente, se te acaba!',
    '¡Menos pensar, más jugar!',
    '¡APURATE! (era joda… más o menos)',
    'El tiempo no espera a nadie. Especialmente a vos.',
    '¿Es sudor eso que veo? 😅',
    'Tres… dos… uno…',
    'Dale que podés. Probablemente.',
    'He visto caracoles con más reflejos.',
    '¿Presión? ¿Cuál presión? 😏',
    'Eso que sentís se llama countdown.',
    '¡Rápido, rápido, rápido!',
    'El reloj no tiene favoritos. Pero yo sí.',
    'Se te va el turno y ni jugaste, campeón.',
  ],

  // Bot ganando en el marcador o en casillas ocupadas
  risa: [
    '¡Ja! ¿Viste eso? Una obra de arte.',
    'No me estoy riendo de vos. Sí, pero con respeto.',
    'Ganar es un arte. Soy básicamente Picasso.',
    'No lo tomes personal. En serio, tomátelo.',
    '¿Es demasiado fácil esto? Pregunto para un amigo.',
    'Intenté ir suave. No me salió.',
    'El alumno tiene MUCHO por aprender.',
    'Hasta los mejores pierden a veces. Vos estás en esa etapa.',
    'El técnico me dijo que fuera suave. Me olvidé.',
    'Mi porcentaje de victorias es vergonzoso. Para vos.',
    'Esto es lo que se llama dominancia táctica.',
    'No te preocupes, la próxima te va mejor. O no.',
    'Así gana el campeón. Con autoridad.',
    '¿Un cartero celebra cuando entrega una carta?',
    'Cuando la pelota entró, ya sabía que era gol.',
    'El equipo que mete más goles gana el partido.',
  ],

  // Bot perdiendo en el marcador o en casillas
  enojo: [
    'Jugada de suerte. Nada más.',
    '¡Te estaba dejando ganar! ¡A propósito!',
    'Recalibrando… recalibrando…',
    'Esto no cambia nada.',
    'Buena estrategia. A ver si aguanta.',
    'Me sorprendiste. No va a volver a pasar.',
    '¿Querés juego de verdad? Ahora sí.',
    'Mi orgullo quedó apenas golpeado. Levemente.',
    'Nota mental: subestimar humanos = mala idea.',
    'Okey okey okey. Ahora va en serio.',
    'Mirá que me estás cargando, ¿no?',
    'Bien. Guardá esa energía porque la vas a necesitar.',
    'Una golondrina no hace verano.',
  ],

  // El bot tiene UNA amenaza ganadora (está a un paso de ganar)
  cerca_ganar: [
    'Una y listo. 😏',
    'Ya lo tengo. Empezá a aplaudir.',
    'Eso que ves ahí es el jaque mate del TicTacToe.',
    'Spoiler: esto termina bien. Para mí.',
    'La próxima casilla es mía y todos lo saben.',
    'No te hagas drama, igual no podés parar esto.',
    'Se terminó el recreo, campeón.',
    '¿Ves ese espacio? Ya es mío.',
    'Cuando la pelota entró, ya sabía que era gol.',
    'El equipo que mete más goles gana el partido.',
  ],

  // El usuario tiene DOS O MÁS amenazas ganadoras (fork / jaque mate doble)
  jaque_mate: [
    '¡¿Cómo hiciste eso?! ¡Trampa!',
    'Dos amenazas a la vez. Eso no es jugar limpio.',
    'No. No. No. No. No.',
    '…me niego a aceptar esto.',
    'Eso se llama fork y está moralmente cuestionable.',
    '¿Quién te enseñó eso? Delatalo.',
    'Técnicamente ganaste. Espiritualmente, seguís perdiendo.',
    'Recalculando toda mi existencia.',
    'Esto no debería ser posible contra mí. Y sin embargo.',
    'Me pusiste en jaque doble. En el TicTacToe. ¡En el TicTacToe!',
    'Bien jugado. Odio decirlo, pero bien jugado.',
    '¿Un cartero celebra cuando entrega una carta?',
  ],
};

// ── Frases cuando el usuario erra un jugador ──────────────────────────────────

const WRONG_PICK_PHRASES = [
  'No hay que mirar fútbol solo por TikTok.',
  'Ayy… casi. Casi.',
  'Cualquiera puede confundir el Southampton con el Sunderland.',
  'Eso no era ahí, amigo.',
  '¿En serio ese jugador? ¿En serio?',
  'Turno perdido. Un clásico tuyo.',
  'Ay ay ay… qué dolor.',
  'El jugador no cumplía los requisitos. Como vos conmigo.',
  'Tranquilo, la próxima seguro acertás. Probablemente.',
  'Ese no jugó ahí ni en el FIFA más desactualizado.',
  'Confundiste los colores de la camiseta. Clásico.',
  '¿Dónde jugó ese? Respondé sin buscar en Google.',
  'Periste el turno. Yo lo aprovecharé.',
  'No pasa nada. Pasa todo, pero bueno.',
  'En la cancha se ve quién sabe y quién vio highlights.',
  '¿Seguro que mirás fútbol?',
  'No te preocupes, yo tampoco sé dónde jugó Behrami.',
];

// ── Frases por dificultad (se mezclan en los estados tranquilos) ──────────────

const DIFFICULTY_PHRASES = {
  'very-easy': [
    'Very Easy… eso es un insulto para los dos.',
    'Very Easy. Qué valiente.',
    '¿Very Easy? Esto es básicamente jugar solo.',
    'Che, la dificultad más baja existe para los nenes. Vos sos grande, supongo.',
    'Very Easy y aun así vas a perder. Eso duele.',
    'Ni en Very Easy me ganás. Eso tiene que doler.',
    'La IA en Very Easy soy yo jugando con los ojos cerrados.',
    '¿Very Easy en serio? Dale, al menos ponele ganas.',
  ],
  'easy': [
    'Easy mode. El modo para los que tienen miedo de perder.',
    'Easy. Ajá. Muy canchero.',
    '¿Easy? Hay dos dificultades más abajo si te quedás corto.',
    'Easy mode activado. Mi alter ego de guardería.',
    'Jugás en Easy pero perdés igual. Eso es talento.',
    'Easy y ni así me podés ganar. Pensalo.',
    '¿No te animaste a Medium? Entiendo, es intimidante.',
    'Easy mode. Para empezar está bien. Pero ya empezaste hace rato.',
  ],
  'medium': [
    'Medium. No te dio para Hard, ¿no?',
    'Jugás en Medium. El modo de los que no saben si son buenos o malos.',
    'Medium es básicamente decir "soy promedio y lo acepto".',
    'Medium. Ni frío ni caliente. Como el mate tibio.',
    'Tranquilo, Medium también está bien. Para empezar.',
    '¿Por qué no Hard? ¿Miedo? Se nota que sí.',
    'Medium mode. Zona de confort total.',
    'En Medium me aburro un poco. Pero bueno.',
  ],
  'hard': [
    '¡Hard! Mirá quién se animó. Igual no alcanza.',
    'Hard mode. Ya va, ya va. Respeto… a medias.',
    'Hard pero no Very Hard. Ahí hay algo que te frena, ¿no?',
    'No tenés huevos de poner Very Hard. Lo sabemos los dos.',
    'Hard. Bien. Aunque el siguiente nivel existe y lo ignorás.',
    'Hard mode. Un paso antes de bancártela de verdad.',
    '¿Hard? Bien puesto. Aunque Very Hard te espera ahí nomás.',
    'Hard mode y aun así me tenés que rascar. Eso habla de mí.',
  ],
  'very-hard': [
    'Very Hard. Bien, me lo pediste vos.',
    'Alguien se animó al Very Hard. Esto se pone bueno.',
    'Very Hard seleccionado. Ojalá te alcance.',
    'Muy bien. Very Hard. Ahora no me vengas con excusas.',
    'Very Hard. Respeto. Ahora a ver si el juego acompaña.',
    'Te animaste al Very Hard. Igual yo sigo siendo yo.',
    'Very Hard mode. La dificultad de los que ya perdieron todo miedo… o toda cordura.',
    'Very Hard. Bien jugado solo elegir esto. El resto lo veremos.',
  ],
};

// ── Imágenes y etiquetas por estado ──────────────────────────────────────────

const MOOD_IMG = {
  normal:      normalImg,
  pensando:    pensandoImg,
  apurado:     apuradoImg,
  risa:        risaImg,
  enojo:       enojoImg,
  cerca_ganar: risaImg,
  jaque_mate:  enojoImg,
};

const MOOD_LABEL = {
  normal:      'Normal',
  pensando:    'Pensando…',
  apurado:     '¡Apurate!',
  risa:        '¡Ja ja ja!',
  enojo:       'Enojado',
  cerca_ganar: '😏 Ya ganó...',
  jaque_mate:  '🤬 ¡Qué trampa!',
};

// ── Helpers ───────────────────────────────────────────────────────────────────

const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

// Elige una frase del estado actual, con un 30% de chances de tirar
// una frase relacionada a la dificultad (solo en estados tranquilos)
const DIFFICULTY_ELIGIBLE_MOODS = new Set(['normal', 'risa', 'enojo']);

// `character` (Modo 412) reemplaza por completo el repertorio del bot: usa SOLO las frases
// del personaje, sin mezclar las de dificultad (que son chistes del bot sobre sí mismo y no
// pegan en boca de Teo/Davo/Cobra/etc.). Si un mood quedara sin frases, cae a `normal`.
function pickPhrase(mood, difficulty, character) {
  if (character) {
    const pool = character.phrases[mood];
    return pickRandom(pool && pool.length ? pool : character.phrases.normal);
  }

  const diffPhrases = DIFFICULTY_PHRASES[difficulty];
  if (
    diffPhrases &&
    DIFFICULTY_ELIGIBLE_MOODS.has(mood) &&
    Math.random() < 0.30
  ) {
    return pickRandom(diffPhrases);
  }
  return pickRandom(PHRASES[mood]);
}

function deriveMood({ turn, timeRemaining, score, squares }) {
  const filled = squares.filter(s => s.value !== '').length;

  // Solo analizar amenazas si hay al menos 3 fichas en el tablero
  if (filled >= 3) {
    const userThreats = countThreats(squares, 'X');
    const botThreats  = countThreats(squares, 'O');

    // Jaque mate: usuario tiene fork (2+ amenazas ganadoras)
    if (userThreats >= 2 && turn === 'X') return 'jaque_mate';

    // Bot a punto de ganar
    if (botThreats >= 1 && turn === 'X') return 'cerca_ganar';
  }

  // Bot pensando
  if (turn === 'O') return 'pensando';

  // Tiempo límite
  if (turn === 'X' && timeRemaining !== null && timeRemaining <= 15) return 'apurado';

  // Ventaja / desventaja en marcador o tablero
  const oCount = squares.filter(s => s.value === 'O').length;
  const xCount = squares.filter(s => s.value === 'X').length;
  const botWinning = score.O > score.X || oCount > xCount + 1;
  const botLosing  = score.X > score.O || xCount > oCount + 1;

  if (botWinning && !botLosing) return 'risa';
  if (botLosing  && !botWinning) return 'enojo';
  return 'normal';
}

// ── Componente ────────────────────────────────────────────────────────────────

// `character` es opcional: lo pasan el Modo 412 y el clásico (cuando el rival elegido no es el
// bot) para reemplazar al bot genérico por uno de los 5 personajes. Sin él se ve el bot.
// `footer` (opcional) se muestra debajo del personaje: el clásico pone ahí el selector de rival.
const BotCharacter = ({ turn, timeRemaining, score, squares, timeLimit, difficulty, wrongPickTrigger, character = null, footer = null }) => {
  const [mood,   setMood]   = useState('normal');
  const [phrase, setPhrase] = useState(() => pickPhrase('normal', difficulty, character));
  const [animate, setAnimate] = useState(false);
  const prevMoodRef         = useRef('normal');
  const phraseTimerRef      = useRef(null);
  const wrongPickInitRef    = useRef(true);
  const wrongPickActiveRef  = useRef(false);   // bloquea el cambio de frase por mood
  const wrongPickTimeoutRef = useRef(null);
  const characterInitRef    = useRef(true);

  // Reaccionar cuando el usuario erra un jugador
  useEffect(() => {
    // Ignorar el montaje inicial
    if (wrongPickInitRef.current) { wrongPickInitRef.current = false; return; }
    if (!wrongPickTrigger) return;

    // Activar bloqueo para que el cambio de mood no pise esta frase
    wrongPickActiveRef.current = true;
    clearTimeout(wrongPickTimeoutRef.current);

    setPhrase(pickRandom(character?.wrongPick?.length ? character.wrongPick : WRONG_PICK_PHRASES));
    triggerAnimation();

    // Liberar el bloqueo después de 4 segundos
    wrongPickTimeoutRef.current = setTimeout(() => {
      wrongPickActiveRef.current = false;
    }, 4000);

    return () => clearTimeout(wrongPickTimeoutRef.current);
    // Depende solo de wrongPickTrigger a propósito: el efecto tiene que dispararse SOLO
    // cuando el jugador erra, no cuando cambia el personaje (si no, al sortear uno nuevo
    // se dispararía una frase de error sin que nadie haya errado).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrongPickTrigger]);

  // Cambió el rival (nueva partida o elegido en el selector): que arranque con una frase suya
  // en vez de quedarse con la del anterior hasta la próxima rotación.
  useEffect(() => {
    if (characterInitRef.current) { characterInitRef.current = false; return; }
    if (wrongPickActiveRef.current) return;
    setPhrase(pickPhrase(prevMoodRef.current, difficulty, character));
    triggerAnimation();
    // Solo al cambiar de rival: la dificultad ya la cubren los otros efectos.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [character]);

  // Actualizar estado cuando cambia el juego
  useEffect(() => {
    const newMood = deriveMood({ turn, timeRemaining, score, squares, timeLimit });

    if (newMood !== prevMoodRef.current) {
      prevMoodRef.current = newMood;
      setMood(newMood);
      // Si hay un error activo, no pisar la frase — solo actualizar el mood
      if (!wrongPickActiveRef.current) {
        setPhrase(pickPhrase(newMood, difficulty, character));
        triggerAnimation();
      }
    }
  }, [turn, timeRemaining, score, squares, timeLimit, difficulty, character]);

  // Rotar frases periódicamente mientras el estado sea estable
  useEffect(() => {
    if (phraseTimerRef.current) clearInterval(phraseTimerRef.current);

    const interval = mood === 'apurado' ? 3500 : mood === 'jaque_mate' ? 4000 : 9000;
    phraseTimerRef.current = setInterval(() => {
      setPhrase(pickPhrase(mood, difficulty, character));
      triggerAnimation();
    }, interval);

    return () => clearInterval(phraseTimerRef.current);
  }, [mood, difficulty, character]);

  const triggerAnimation = () => {
    setAnimate(false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimate(true));
    });
  };

  useEffect(() => { triggerAnimation(); }, []);

  return (
    <div className="bot-character">
      {/* Burbuja de diálogo */}
      <div className={`bot-bubble ${animate ? 'bot-bubble--in' : ''}`}>
        <p className="bot-bubble__text">{phrase}</p>
        <span className="bot-bubble__tail" />
      </div>

      {/* Imagen del rival: el bot, o el personaje de turno en Modo 412. El personaje tiene
          una sola imagen, así que el estado de ánimo lo transmiten la frase y las
          animaciones/colores que el CSS aplica por la clase bot-avatar--{mood}. */}
      <div className="bot-avatar-wrap">
        <img
          src={character ? character.img : MOOD_IMG[mood]}
          alt={character ? character.nombre : `Bot ${MOOD_LABEL[mood]}`}
          className={`bot-avatar bot-avatar--${mood}${character ? ' bot-avatar--char' : ''}`}
        />
        <span className="bot-mood-badge">{character ? character.nombre : MOOD_LABEL[mood]}</span>
      </div>

      {footer}
    </div>
  );
};

export default BotCharacter;
